import { languageURL } from "./routes";
const TEXT_FIELDS = new Set(["name", "description", "text", "serviceType", "alternateName"]);
const URL_FIELDS = new Set(["url", "item", "@id", "mainEntityOfPage"]);
export function localizedSchema(value, t, key = "") {
    if (Array.isArray(value)) return value.map((item) => localizedSchema(item, t, key));
    if (typeof value === "string") {
        if (URL_FIELDS.has(key) && value.startsWith("https://vvpsstaxiservices.com/") && !/#(?:business|organization)$/.test(value)) return languageURL(value, "hi");
        return TEXT_FIELDS.has(key) ? t(value) : value;
    }
    if (!value || typeof value !== "object") return value;
    if (/#(?:business|organization)$/.test(value["@id"] || "")) return value;
    const result = Object.fromEntries(Object.entries(value).map(([field, item]) => [field, localizedSchema(item, t, field)]));
    if (["WebPage", "CollectionPage", "FAQPage"].includes(result["@type"])) result.inLanguage = "hi-IN";
    return result;
}
